import { CardHistory } from "@/modules/card/components";
import { PageHeader } from "@/shared/components";

export const CardHistoryPage = () => {
  return (
    <div className="full-width page-container">
      <PageHeader/>
      <CardHistory/>
    </div>
  );
};
